import { useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { clearToken } from "../../utils/clearToken";


const useSamlLogout = (clearIndexedDB) => {
  const navigate = useNavigate();
  const location = useLocation();
  const Logoutpath  = sessionStorage.getItem("currentPath", location.pathname);




  const handleLogout = async () => {
    try {
      if (typeof clearIndexedDB === "function") {
        await clearIndexedDB();
      }
    } catch (err) {
      console.error("Error clearing IndexedDB:", err);
    }

    sessionStorage.clear();
    localStorage.setItem("logout", Date.now());
    clearToken(1000);
    navigate(
      Logoutpath === "/login/sib"  ? "/login/sib": "/login/conops",
      { replace: true }
    );
  };

  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === "logout") {
        sessionStorage.clear();
        clearToken(0); 
        navigate(
          Logoutpath === "/login/sib"  ? "/login/sib": "/login/conops",
          { replace: true }
        );
      }
    };

    window.addEventListener("storage", handleStorageEvent);
    return () => window.removeEventListener("storage", handleStorageEvent);
  }, [navigate]);

  return { handleLogout };
};

export default useSamlLogout;
